import { render, staticRenderFns } from "./ParleSend.vue?vue&type=template&id=1e4fcb0d&scoped=true&"
import script from "./ParleSend.vue?vue&type=script&lang=js&"
export * from "./ParleSend.vue?vue&type=script&lang=js&"
import style0 from "./ParleSend.vue?vue&type=style&index=0&id=1e4fcb0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fcb0d",
  null
  
)

export default component.exports